import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AppointmentForm from '../components/Appointment/AppointmentForm';
import axios from 'axios';

// API URL sabiti
const API_URL = 'https://api.345.tr/v1.3';

export interface AppointmentPageProps {
  website: {
    salonInfo: any;
    content: {
      appointmentDescription?: string;
    };
  };
}

const AppointmentPage: React.FC<AppointmentPageProps> = ({ website }) => {
  const [backgroundImage, setBackgroundImage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchRandomSalonPhoto = async () => {
      try {
        if (website?.salonInfo?._id) {
          const response = await axios.get(`${API_URL}/salon/${website.salonInfo._id}/photo`);
          
          if (response.data.success && response.data.photo && response.data.photo.photoUrl) {
            const photoUrl = response.data.photo.photoUrl;
            // URL formatını kontrol et
            const fullUrl = photoUrl.startsWith('http') 
              ? photoUrl 
              : `${API_URL}${photoUrl}`;
            
            console.log('Randevu sayfası için rastgele fotoğraf yüklendi:', fullUrl);
            setBackgroundImage(fullUrl);
          }
        }
      } catch (error) {
        console.error('Rastgele salon fotoğrafı yüklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRandomSalonPhoto();
  }, [website]);

  // Açıklama metnini content'ten al veya varsayılan kullan
  const appointmentDescription = website?.content?.appointmentDescription || 
    'Birkaç kolay adımda istediğiniz hizmet için randevu oluşturabilirsiniz. Size uygun tarihi ve saati seçerek, profesyonel ekibimizle buluşun.';

  return (
    <AppointmentPageContainer>
      <PageHeader backgroundImage={backgroundImage}>
        <div className="container">
          <PageTitle>Randevu Oluştur</PageTitle>
          <PageDescription>
            {appointmentDescription}
          </PageDescription>
        </div>
      </PageHeader>

      <section className="container">
        <FormSection>
          <AppointmentForm salonId={website?.salonInfo?._id} />
        </FormSection>
      </section>
    </AppointmentPageContainer>
  );
};

const AppointmentPageContainer = styled.div`
  margin-top: 80px;
`;

const PageHeader = styled.div<{ backgroundImage: string | null }>`
  background: linear-gradient(145deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.4) 100%);
  padding: 100px 0 60px;
  text-align: center;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.backgroundImage || '/images/salon1.jpg'});
    background-size: cover;
    background-position: center;
    opacity: 0.35;
    z-index: -1;
    filter: saturate(1.1) contrast(1.1);
  }
  
  // Modern gölge efekti ekle
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 40px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.08), transparent);
    z-index: -1;
  }
`;

const PageTitle = styled.h1`
  margin-bottom: 25px;
  position: relative;
  display: inline-block;
  font-size: 3.2rem;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  background: linear-gradient(45deg, ${({ theme }) => theme.colors.primary}, ${({ theme }) => theme.colors.secondary});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  letter-spacing: 1px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  
  &:after {
    content: '';
    display: block;
    width: 80px;
    height: 3px;
    background: linear-gradient(to right, ${({ theme }) => theme.colors.primary}, ${({ theme }) => theme.colors.secondary});
    margin: 15px auto 0;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2.5rem;
  }
`;

const PageDescription = styled.p`
  color: white;
  font-size: 1.2rem;
  font-family: 'Poppins', sans-serif;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.8;
  font-weight: 300;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1.1rem;
    padding: 0 20px;
  }
`;

const FormSection = styled.div`
  padding: 60px 0;
  max-width: 1100px;
  margin: 0 auto;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  background-color: white;
  margin-top: -50px;
  position: relative;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: -30px;
    padding: 40px 0;
  }
`;

export default AppointmentPage; 